var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-component",on:{"click":function($event){return _vm.handleClickInternal()}}},[_c('h1',[_vm._v(_vm._s(_vm.index + ' ' + _vm.msg)+": "+_vm._s(_vm.data.data.time)+" "+_vm._s(_vm.numClicks))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fee50b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserList.vue
// module id = null
// module chunks = 